import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full mb-6 flex flex-wrap items-center gap-x-4 gap-y-3 rounded-md border border-gray-200 bg-white px-4 py-3 text-left shadow-sm",
  "aria-labelledby": "tutor-password-banner-title"
}
const _hoisted_2 = {
  class: "flex flex-1 items-start gap-3",
  style: {"min-width":"18rem"}
}
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  class: "mt-0.5 h-5 w-5 flex-none text-yellow-600",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("rect", {
    x: "5",
    y: "11",
    width: "14",
    height: "10",
    rx: "2"
  }),
  /*#__PURE__*/_createVNode("path", { d: "M8 11V7a4 4 0 0 1 8 0v4" })
], -1)
const _hoisted_4 = { class: "min-w-0" }
const _hoisted_5 = {
  id: "tutor-password-banner-title",
  class: "text-sm font-bold text-gray-800"
}
const _hoisted_6 = { class: "ml-2 inline-block text-yellow-700" }
const _hoisted_7 = { class: "mt-0.5 text-xs text-gray-600" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 期限を過ぎると、変更するまでほかの機能が使えなくなります。")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("詳細はこちら ↗")
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "（新しいタブで開きます）", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("今すぐ変更する")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MButton = _resolveComponent("MButton")

  return (_ctx.status && _ctx.status.showBanner)
    ? (_openBlock(), _createBlock("section", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode("h2", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.deadline) + "までにパスワードの変更をお願いします", 1),
              _createVNode("span", _hoisted_6, _toDisplayString(_ctx.daysLeft), 1)
            ]),
            _createVNode("p", _hoisted_7, [
              _hoisted_8,
              _createVNode("a", {
                href: _ctx.guideUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "ml-1 whitespace-nowrap text-blue-700 underline hover:text-blue-800"
              }, [
                _hoisted_9,
                _hoisted_10
              ], 8, ["href"])
            ])
          ])
        ]),
        _createVNode(_component_MButton, {
          class: "ml-auto flex-none",
          color: "primary-500",
          "hover-color": "primary-600",
          "font-weight": "bold",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (
        _ctx.$router.push({ path: '/change_password', query: { from: '/home' } })
      ))
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}